export function parseDuration(durationStr) {
  // Supports "HH:MM:SS", "MM:SS", or "MM"
  // Returns total seconds
  if (!durationStr) return 0;
  const parts = durationStr.split(':').map(Number);
  if (parts.length === 3) {
    return parts[0] * 3600 + parts[1] * 60 + parts[2];
  } else if (parts.length === 2) {
    return parts[0] * 60 + parts[1];
  } else if (parts.length === 1) {
    return parts[0] * 60;
  }
  return 0;
}

export function formatTimeLeft(seconds) {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export function isSessionExpired(startedAt, duration) {
  if (!startedAt || !duration) return true;
  const elapsed = Math.floor((Date.now() - new Date(startedAt).getTime()) / 1000);
  return elapsed >= parseDuration(duration);
}